import Vue from 'vue'
import { format, parseISO } from 'date-fns'

Vue.filter('formatTime', function (value) {
  if (value) {
    let date = parseISO(String(value).trim())
    return format(date, 'h:mm a').toLowerCase()
  }
})
